module.exports = __webpack_public_path__ + "img/file-earmark-richtext-fill.29452d83.svg";